import { asBondPriceNominal, BondPriceNominal, Money, OrderDirection } from "@goodfill/domain-properties";
import { calculateGoodfillTransactionCommissionForAmount } from "../goodfillTransactionCommission/calculateGoodfillTransactionCommissionForAmount";

export function excludeGoodfillCommissionFromLoadedPrice(
  loadedPrice: BondPriceNominal,
  faceAmount: Money,
  orderDirection: OrderDirection,
): BondPriceNominal {
  const goodfillCommission = calculateGoodfillTransactionCommissionForAmount(faceAmount);

  if (orderDirection === OrderDirection.Buy) {
    return asBondPriceNominal(loadedPrice.minus(goodfillCommission.commissionRate));
  } else {
    return asBondPriceNominal(loadedPrice.plus(goodfillCommission.commissionRate));
  }
}

export function includeGoodfillCommissionWithBasePrice(
  basePrice: BondPriceNominal,
  faceAmount: Money,
  orderDirection: OrderDirection,
): BondPriceNominal {
  const goodfillCommission = calculateGoodfillTransactionCommissionForAmount(faceAmount);

  if (orderDirection === OrderDirection.Buy) {
    return asBondPriceNominal(basePrice.plus(goodfillCommission.commissionRate));
  } else {
    return asBondPriceNominal(basePrice.minus(goodfillCommission.commissionRate));
  }
}
